import { Component, OnInit, Input } from '@angular/core';
import { ItemDetail } from 'src/app/models/item-detail.model';

@Component({
  selector: 'app-call-note',
  templateUrl: './call-note.component.html',
  styleUrls: [
    './call-note.component.scss',
    './../../../../assets/scss/call-screen.scss'
  ]
})
export class CallNoteComponent implements OnInit {
  @Input() items: ItemDetail[];

  constructor() { }

  ngOnInit(): void {
  }

}
